module.exports = __webpack_public_path__ + "img/project_e3.0472be64.png";